import { LayoutGrid, Loader2 } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { useCoverage } from "../context/CoverageContext";
import { HubRow } from "./HubRow";

export const HubLandscapeGrid = () => {
  const {
    filteredHubs,
    hubsLoading,
    hubsFetching,
    hubsError,
    activeFilter,
    searchQuery,
    setActiveFilter,
    setSearchQuery,
  } = useCoverage();

  if (hubsLoading && filteredHubs.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center text-muted-foreground">
        <Loader2 className="size-5 animate-spin" />
        <p className="text-xs">Loading hubs…</p>
      </div>
    );
  }

  if (hubsError && filteredHubs.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 px-8 text-center">
        <p className="text-sm text-muted-foreground">Couldn’t load coverage hubs.</p>
      </div>
    );
  }

  if (filteredHubs.length === 0 && hubsFetching) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center text-muted-foreground">
        <Loader2 className="size-5 animate-spin" />
        <p className="text-xs">Loading hubs…</p>
      </div>
    );
  }

  if (filteredHubs.length === 0) {
    const isUnfiltered = activeFilter === "all" && !searchQuery.trim();
    if (isUnfiltered) {
      return (
        <div className="flex h-full flex-col items-center justify-center gap-4 px-8 text-center">
          <LayoutGrid className="size-6 text-muted-foreground/50" />
          <div className="space-y-1.5">
            <h3 className="text-sm font-semibold text-foreground">No problem hubs yet</h3>
            <p className="text-xs text-muted-foreground">
              Activate a completed Context to generate problem tags and start tracking coverage.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-sm text-muted-foreground">No hubs match the current filter.</p>
        <Button
          variant="link"
          size="sm"
          className="mt-1.5 text-xs"
          onClick={() => {
            setActiveFilter("all");
            setSearchQuery("");
          }}
        >
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <div className="relative">
      {hubsFetching && !hubsLoading && (
        <div className="pointer-events-none absolute right-0 top-0 z-10">
          <Loader2
            className="size-3.5 animate-spin text-muted-foreground/50"
            aria-label="Refreshing hubs"
          />
        </div>
      )}
      <div
        className={
          hubsFetching && !hubsLoading
            ? "flex flex-col gap-1.5 opacity-70 transition-opacity"
            : "flex flex-col gap-1.5"
        }
      >
        {filteredHubs.map((hub) => (
          <HubRow key={hub.id} hub={hub} />
        ))}
      </div>
    </div>
  );
};
